<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon medium class="mr-2" v-on="on" @click.stop="openDialog">
          edit
        </v-icon>
      </template>
      <span>{{ $t("settings.editUser") }}</span>
    </v-tooltip>
    <v-dialog v-model="open" max-width="520">
      <v-card>
        <v-card-title class="headline">{{ $t("settings.editUser") }}</v-card-title>
        <v-card-text>
          <b>{{ item.name }} ({{ item.email }})</b>
          <v-combobox
            v-model="tagNames"
            :search-input.sync="tagSearch"
            :items="tagItems"
            :label="$t('accessRoles.tags')"
            multiple
            chips
            small-chips
            deletable-chips
            hide-selected
            dense
            class="mt-4"
            @blur="commitTagSearch"
          ></v-combobox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="open = false">{{ $t("general.cancel") }}</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">
            {{ $t("general.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from "axios";

export default {
  props: ["item"],
  data: () => ({
    open: false,
    saving: false,
    tagNames: [],
    tagSearch: "",
  }),
  computed: {
    tagItems() {
      return this.$store.getters.allUserTags.map((t) => t.tag);
    },
  },
  methods: {
    async openDialog() {
      await this.$store.dispatch("getAllUserTags");
      this.tagNames = (this.item.tags || []).map((t) => {
        if (t && typeof t === "object") return t.tag;
        const doc = this.$store.getters.allUserTags.find(
          (x) => String(x._id) === String(t)
        );
        return doc ? doc.tag : t;
      });
      this.tagSearch = "";
      this.open = true;
    },
    commitTagSearch() {
      const text = String(this.tagSearch || "").trim();
      if (!text) return;
      const exists = this.tagNames.some(
        (name) => String(name).toLowerCase() === text.toLowerCase()
      );
      if (!exists) this.tagNames = [...this.tagNames, text];
      this.tagSearch = "";
    },
    async save() {
      this.commitTagSearch();
      this.saving = true;
      try {
        await axios.put(`user/${this.item._id || this.item.id}/tags`, {
          tags: this.tagNames,
        });
        this.open = false;
        this.$emit("reloadData");
      } catch (e) {
        this.$store.dispatch("triggerError", e);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
